import {Component, OnInit} from '@angular/core';
import {MatDialog} from '@node_modules/@angular/material';

@Component({
    selector: 'app-terms',
    templateUrl: './terms.component.html',
    styleUrls: ['./terms.component.scss']
})
export class TermsComponent implements OnInit {
    static modalRef;

    constructor(
        public dialog: MatDialog,
    ) {
    }

    ngOnInit() {
    }

    onClose() {
        // this.dialog.closeAll();
        if (TermsComponent.modalRef) {
            TermsComponent.modalRef.close();
        }
    }

}
